import { useCallback, useMemo } from "react";
import SetSelector from "components/Inputs/SetSelector";
import { useChartSetSelectContext } from "components/charting/contexts/ChartSetSelectContext";
import { useChartCompareSetSelectContext } from "components/charting/contexts/ChartCompareSetSelectContext";
import { style } from "config";
import { useTranslation } from "react-i18next";
import type { MeasurementSet } from "types";

function AthleteProfileChartCompareSetSelectorV1() {
  const { t } = useTranslation();
  const { value, options, onChange } = useChartCompareSetSelectContext();
  const { value: selectedPrimarySets } = useChartSetSelectContext();

  const getOptionDisabled = useCallback(
    (option: MeasurementSet) => selectedPrimarySets.includes(option),
    [selectedPrimarySets]
  );

  const handleChange = useCallback((_: unknown, sets: MeasurementSet[]) => onChange(sets), [onChange]);

  const CheckboxProps = useMemo(() => ({ sx: { color: style.colors.options[1] } }), []);
  const TextFieldProps = useMemo(
    () => ({ label: t("athlete_profile_chart_compare_set_selector.compare_set_select_label") }),
    [t]
  );

  return (
    <SetSelector
      value={value}
      options={options}
      onChange={handleChange}
      getOptionDisabled={getOptionDisabled}
      CheckboxProps={CheckboxProps}
      TextFieldProps={TextFieldProps}
    />
  );
}

export default AthleteProfileChartCompareSetSelectorV1;
